// extracted by mini-css-extract-plugin
module.exports = {"theme":"ThemeSwitcher_theme__134ul","themeSwitch":"ThemeSwitcher_themeSwitch__2A03Q"};